module.exports = __webpack_public_path__ + "img/round-arrow-trans.a4fbee1a.svg";